import * as THREE from "three";
import { jsondan } from "../../FikoThreeType";
import { FikoGrup } from "../FikoGrup";
import { FikoObje3D } from "../FikoObje3D";
import { FikoSahne } from "../FikoSahne";
import { KonumlarComponent } from "./konumlar.component";

declare var TWEEN: any;


export interface IKonum {
    matriks?: Array<number>,
    hedef?: Array<number>,
    ust?: Array<number>,
    yakinlik?: number,
    oran?: number,
    position?: Array<number>,
    quaternion?: Array<number>,
    scale?: Array<number>,
    [key: string]: any  // OrthographicCameraJSON uyumluluğu için
}

export class FikoKonumlar extends FikoGrup {
    override type: any = "FikoKonumlar";
    /** */
    override name: string = "Fiko Konumlar";
    /** */
    sagButonlar = [
        {
            isim: "Konum Ekle",
            simge: "plus",
            tiklandi: () => {
                const kameraJSON = this.sahne.anaGosterim.aktifKamera.toJSON() as any;
                const veri = {
                    position: kameraJSON.object?.position || this.sahne.anaGosterim.aktifKamera.position.toArray(),
                    quaternion: kameraJSON.object?.quaternion || this.sahne.anaGosterim.aktifKamera.quaternion.toArray(),
                    scale: kameraJSON.object?.scale || this.sahne.anaGosterim.aktifKamera.scale.toArray(),
                    ust: kameraJSON.object?.up || this.sahne.anaGosterim.aktifKamera.up.toArray(),
                    yakinlik: kameraJSON.object?.zoom || this.sahne.anaGosterim.aktifKamera.zoom,
                    hedef: this.sahne.anaGosterim.aktifKontrol.target.toArray(),
                    oran: this.sahne.anaGosterim.canvas.nativeElement.clientWidth / this.sahne.anaGosterim.canvas.nativeElement.clientHeight,
                    matriks: kameraJSON.object?.matrix || this.sahne.anaGosterim.aktifKamera.matrix.toArray()
                };
                this.ekle(new FikoKonum(this.sahne, null, null, veri) as any);
                this.sahne.anaGosterim.FikoYT.degisti.emit();
            }
        },
    ];
    /** */
    sagMenu: any[] = [
        {
            baslik: "Düzenle",
            simge: "edit",
            tiklandi: () => {
                this.sahne.anaGosterim.DialogFiko.ac({
                    bilesen: KonumlarComponent,
                    parametreler: { sahne: this.sahne, konumlar: this },
                    $event: null,
                    ayarlar: { baslik: 'FikoYT Konumlar', simgeResim: './simgeler/kamera.webp' }
                });
            }
        }

    ]
    // fikoThreejs
    constructor(public override sahne: FikoSahne) {
        super(sahne);

        this.userData.FikoArayuz.agactaGorunur = true;
        this.userData.FikoArayuz.listeGoster = false;
        this.userData.FikoArayuz.simge = "./simgeler/kamera.webp";
    }


    // okuJsondan(json:any){
    //     this.up.fromArray(json.ust);
    //     this.zoom = json.yakinlik;
    //     this.matrix.fromArray(json.matriks);
    //     this.matrix.decompose(this.position, this.quaternion, this.scale);

    //     this.anaGosterim.aktifKontrol.target.fromArray(json.hedef);
    //     this.anaGosterim.aktifKontrol.update();
    //     this.updateProjectionMatrix()
    // }

    // toJSON() {
    //     return {
    //         matriks: this.matrix.toArray(),
    //         hedef: this.anaGosterim.aktifKontrol.target.toArray(),
    //         ust: this.up.toArray(),
    //         yakinlik: this.zoom,
    //         oran: this.anaGosterim.canvas.nativeElement.clientWidth / this.anaGosterim.canvas.nativeElement.clientHeight,
    //     }
    // }

    kaydet(ismi: string, aciklama: string, veri: IKonum) {
        this.ekle(new FikoKonum(this.sahne, ismi, aciklama, veri) as any);
    }

    /**
     * İsme göre konuma git
     */
    git(isim: string): void {
        const konum = this.children.find(
            (child: any) => child.ismi === isim || child.name === isim
        ) as FikoKonum;

        if (konum && typeof konum.git === 'function') {
            konum.git();
        }
    }

    fromJson(json?: any) {
        this.clear();
        for (let i = 0; i < json.liste.length; i++) {
            let element = json.liste[i];
            this.ekle(new FikoKonum(this.sahne, element.ismi, element.aciklama, element.veri) as any);
        }
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);

        const childs: any[] = []
        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];

            childs.push(element.toJSON());
        }
        _rslt.liste = childs;

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new FikoKonumlar(sahne);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        for (let i = 0; i < json.liste.length; i++) {
            let element = json.liste[i];
            _rslt.ekle(jsondan(sahne, _rslt, element));
        }


        return _rslt;
    }

    ciftTiklandi() {
        this.sahne.anaGosterim.DialogFiko.ac({
            bilesen: KonumlarComponent,
            parametreler: { sahne: this.sahne, konumlar: this },
            $event: null,
            ayarlar: { baslik: 'FikoYT Konumlar', simgeResim: './simgeler/kamera.webp' }
        });
    }

    /**
     * FikoCizimYalin'ın bounding box'ına göre sabit görünüm konumları oluştur
     */
    private hesaplaGorunumKonumlari() {
        // Sahibi olan tüm FikoCizimYalin nesnelerini bul
        const cizimler: any[] = [];
        this.sahne.traverse((obj: any) => {
            if (obj.type === 'FikoCizimYalin') {
                cizimler.push(obj);
            }
        });

        if (cizimler.length === 0) {
            return;
        }

        // Tüm cizimler için bounding box hesapla
        let box = new THREE.Box3();
        cizimler.forEach(cizim => {
            box.expandByObject(cizim);
        });

        const center = new THREE.Vector3();
        box.getCenter(center);
        const size = new THREE.Vector3();
        box.getSize(size);
        const radius = Math.max(size.x, size.y, size.z) / 2 * 1.5; // Padding ile

        const kamera = this.sahne.anaGosterim.aktifKamera;
        const canvas = this.sahne.anaGosterim.canvas.nativeElement;
        const aspect = canvas.clientWidth / canvas.clientHeight;

        // Zoom hesaplama
        const yakinlik = (aspect > 1.0)
            ? canvas.clientHeight / (radius * 2)
            : canvas.clientWidth / (radius * 2);

        const up = new THREE.Vector3(0, 1, 0);

        // Sabit görünümleri oluştur
        const gorunumler = {
            isometrik: this.olusturGorunumKonumu(center, new THREE.Vector3(1, 1, 1).normalize(), radius * 1.5, up, yakinlik, 'İzometrik'),
            ust: this.olusturGorunumKonumu(center, new THREE.Vector3(0, 1, 0), radius, new THREE.Vector3(0, 0, -1), yakinlik, 'Üst'),
            alt: this.olusturGorunumKonumu(center, new THREE.Vector3(0, -1, 0), radius, new THREE.Vector3(0, 0, 1), yakinlik, 'Alt'),
            on: this.olusturGorunumKonumu(center, new THREE.Vector3(0, 0, 1), radius, up, yakinlik, 'Ön'),
            arka: this.olusturGorunumKonumu(center, new THREE.Vector3(0, 0, -1), radius, up, yakinlik, 'Arka'),
            sag: this.olusturGorunumKonumu(center, new THREE.Vector3(1, 0, 0), radius, up, yakinlik, 'Sağ'),
            sol: this.olusturGorunumKonumu(center, new THREE.Vector3(-1, 0, 0), radius, up, yakinlik, 'Sol'),
        };

        return gorunumler;
    }

    /**
     * Görünüm konumu oluştur
     */
    private olusturGorunumKonumu(
        merkez: THREE.Vector3,
        yonu: THREE.Vector3,
        mesafe: number,
        ustYonu: THREE.Vector3,
        yakinlik: number,
        ad: string
    ): any {
        const kameraPos = merkez.clone().add(yonu.clone().multiplyScalar(mesafe));

        // Three.js kamerası için lookAt matrix oluştur
        const matrix = new THREE.Matrix4();
        matrix.lookAt(kameraPos, merkez, ustYonu);

        // Matrix'ten quaternion ve up vector'ünü çıkart
        const quat = new THREE.Quaternion();
        quat.setFromRotationMatrix(matrix);

        // Gerçek up vector'ünü (kamera view'dan) hesapla
        const tempKamera = new THREE.Object3D();
        tempKamera.position.copy(kameraPos);
        tempKamera.quaternion.copy(quat);
        const realUp = new THREE.Vector3(0, 1, 0).applyQuaternion(quat);

        const oran = this.sahne.anaGosterim.canvas.nativeElement.clientWidth /
                     this.sahne.anaGosterim.canvas.nativeElement.clientHeight;

        return {
            position: kameraPos.toArray(),
            quaternion: [quat.x, quat.y, quat.z, quat.w],
            hedef: merkez.toArray(),
            ust: realUp.toArray(),
            yakinlik: yakinlik,
            oran: oran
        };
    }

    /**
     * Sabit görünümleri konumlara ekle
     */
    olusturSabitGorunumler() {
        const gorunumler = this.hesaplaGorunumKonumlari();
        if (!gorunumler) return;

        // Var olan ismetrik, üst, alt, vb. konumları sil
        this.children.forEach(child => {
            if (child instanceof FikoKonum) {
                const isim = (child as any).ismi?.toLowerCase() || '';
                if (['isometrik', 'üst', 'alt', 'ön', 'arka', 'sağ', 'sol'].some(g => isim.includes(g))) {
                    this.remove(child);
                }
            }
        });

        // Yeni konumları ekle
        Object.entries(gorunumler).forEach(([anahtar, veri]: [string, any]) => {
            const konum = new FikoKonum(
                this.sahne,
                this.adlandirGorunum(anahtar),
                `${this.adlandirGorunum(anahtar)} Görünümü`,
                veri
            ) as any;
            this.ekle(konum);
        });

        this.sahne.anaGosterim.FikoYT.degisti.emit();
    }

    /**
     * Görünüm adını Türkçeleştir
     */
    private adlandirGorunum(anahtar: string): string {
        const adlar: { [key: string]: string } = {
            isometrik: 'İzometrik',
            ust: 'Üst',
            alt: 'Alt',
            on: 'Ön',
            arka: 'Arka',
            sag: 'Sağ',
            sol: 'Sol'
        };
        return adlar[anahtar] || anahtar;
    }

    /**
     * Verilen konum verisine göre kamera git (hesaplanan veya kaydedilmiş)
     */
    async gitVeri(veri: IKonum, sure = 750) {
        return new Promise((resolve, reject) => {
            // Animasyon için continuous render başlat
            this.sahne.anaGosterim.surekliCiz();

            const hedefKontrolPoz = new THREE.Vector3().fromArray(veri.hedef || [0, 0, 0])
            const hedefKameraPoz = new THREE.Vector3().fromArray(veri.position || [0, 0, 0])
            const hedefKameraQua = new THREE.Quaternion().fromArray(veri.quaternion || [0, 0, 0, 1])
            const hedefKameraUst = new THREE.Vector3().fromArray(veri.ust || [0, 1, 0])
            const zamanZoom = sure
            const yeniOran = this.sahne.anaGosterim.canvas.nativeElement.clientWidth / this.sahne.anaGosterim.canvas.nativeElement.clientHeight
            const yeniYakinlik = (yeniOran * (veri.yakinlik || 1)) / (veri.oran || 1)

            let completedTweens = 0;
            const totalTweens = 3;

            const checkAllComplete = () => {
                completedTweens++;
                if (completedTweens === totalTweens) {
                    this.sahne.anaGosterim.surekliCizIptal();
                    resolve(true);
                }
            };

            const aktifKamera = this.sahne.anaGosterim.aktifKamera;
            const aktifKontrol = this.sahne.anaGosterim.aktifKontrol;

            // Başlangıç pozisyon ve rotasyonunu sakla
            const baslanqicPoz = new THREE.Vector3().copy(aktifKamera.position);
            let baslanqicQua = new THREE.Quaternion().copy(aktifKamera.quaternion);
            const baslanqicUst = new THREE.Vector3().copy(aktifKamera.up);

            // Hedef quaternion'ı kontrol et - dot product < 0 ise negate et
            const hedefQuaOptimize = new THREE.Quaternion().copy(hedefKameraQua);
            let dotProduct = baslanqicQua.dot(hedefQuaOptimize);
            if (dotProduct < 0) {
                hedefQuaOptimize.x *= -1;
                hedefQuaOptimize.y *= -1;
                hedefQuaOptimize.z *= -1;
                hedefQuaOptimize.w *= -1;
                // Negate ettikten sonra dot product'ı yeniden hesapla
                dotProduct = baslanqicQua.dot(hedefQuaOptimize);
            }

            // Eğer tam zıt yönde ise (dot product ~0), başlangıç quaternion'unu çok hafif döndür
            if (Math.abs(dotProduct) < 0.05) {
                // Çok küçük bir dönüş ekseni oluştur (X ekseni etrafında 0.5 derece)
                const tinyAxis = new THREE.Vector3(1, 0, 0);
                const tinyRotation = new THREE.Quaternion();
                tinyRotation.setFromAxisAngle(tinyAxis, 0.00872665); // ~0.5 derece radyan
                baslanqicQua.multiplyQuaternions(baslanqicQua, tinyRotation);
                baslanqicQua.normalize();

                // Dot product'ı yeniden hesapla
                dotProduct = baslanqicQua.dot(hedefQuaOptimize);
            }

            // Quaternion'ların benzerliğini kontrol et (0 = çok farklı, 1 = aynı)
            const quaternionBenzerligi = Math.abs(dotProduct);

            // Eğer quaternion'lar çok benzerse (1'e çok yakınsa), rotasyon animasyonu yapma
            // Sadece pozisyon animasyonunu yap
            const yalnizPozisyonAnimasyonu = quaternionBenzerligi > 0.95;

            // Eğer dot product çok düşükse, orta quaternion'ı önceden hesapla
            let midQua: THREE.Quaternion | null = null;
            let midQua2: THREE.Quaternion | null = null;

            if (dotProduct < 0.5 && !yalnizPozisyonAnimasyonu) {
                midQua = new THREE.Quaternion().copy(baslanqicQua);
                midQua.slerp(hedefQuaOptimize, 0.5);
            }

            // Eğer çok zıtsa (dot product < 0.1), orta noktayı ayrıca hesapla
            if (Math.abs(dotProduct) < 0.1) {
                midQua2 = new THREE.Quaternion().copy(baslanqicQua);
                midQua2.slerp(hedefQuaOptimize, 0.5);
            }

            // Animasyon progress'ini takip et (0 -> 1)
            const animasyon = { progress: 0 };

            // Kamera pozisyon ve rotasyon animasyonu
            const positionTween = new TWEEN.Tween(animasyon)
                .to({ progress: 1 }, zamanZoom)
                .easing(TWEEN.Easing.Quadratic.InOut)
                .onUpdate(() => {
                    // Position lerp
                    aktifKamera.position.lerpVectors(baslanqicPoz, hedefKameraPoz, animasyon.progress);

                    // Quaternion slerp (smooth rotation)
                    if (!yalnizPozisyonAnimasyonu) {
                        const tempQua = new THREE.Quaternion();

                        // Eğer dot product çok düşükse (180 derece), orta yolda dönüş yap
                        if (midQua2) {
                            if (animasyon.progress < 0.5) {
                                tempQua.copy(baslanqicQua);
                                tempQua.slerp(midQua2, animasyon.progress * 2);
                            } else {
                                tempQua.copy(midQua2);
                                tempQua.slerp(hedefQuaOptimize, (animasyon.progress - 0.5) * 2);
                            }
                        } else if (midQua) {
                            // Orta quaternion varsa (dot product 0.1 - 0.5), iki yoldan git
                            if (animasyon.progress < 0.5) {
                                // Başlangıçtan orta noktaya: 0 → 0.5 progress
                                tempQua.copy(baslanqicQua);
                                tempQua.slerp(midQua, animasyon.progress * 2);
                            } else {
                                // Orta noktadan hedef noktaya: 0.5 → 1.0 progress
                                tempQua.copy(midQua);
                                tempQua.slerp(hedefQuaOptimize, (animasyon.progress - 0.5) * 2);
                            }
                        } else {
                            // Normal slerp
                            tempQua.copy(baslanqicQua);
                            tempQua.slerp(hedefQuaOptimize, animasyon.progress);
                        }

                        aktifKamera.quaternion.copy(tempQua);

                        // Up vector lerp
                        aktifKamera.up.lerpVectors(baslanqicUst, hedefKameraUst, animasyon.progress);
                    } else {
                        // Quaternion aynıysa, sadece up vector'ünü lerp et
                        aktifKamera.up.lerpVectors(baslanqicUst, hedefKameraUst, animasyon.progress);
                    }

                    aktifKamera.updateProjectionMatrix();
                })
                .onComplete(() => {
                    checkAllComplete();
                });

            positionTween.start();

            // Zoom animasyonu
            const zoomAnimasyon = { zoom: aktifKamera.zoom };
            new TWEEN.Tween(zoomAnimasyon)
                .to({ zoom: yeniYakinlik }, zamanZoom)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(() => {
                    aktifKamera.zoom = zoomAnimasyon.zoom;
                    aktifKamera.updateProjectionMatrix();
                })
                .onComplete(() => {
                    checkAllComplete();
                })
                .start();

            // Kontrol hedef animasyonu
            const baslanqicHedef = new THREE.Vector3().copy(aktifKontrol.target);
            const kontrolAnimasyon = { progress: 0 };
            new TWEEN.Tween(kontrolAnimasyon)
                .to({ progress: 1 }, zamanZoom)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(() => {
                    aktifKontrol.target.lerpVectors(baslanqicHedef, hedefKontrolPoz, kontrolAnimasyon.progress);
                    aktifKontrol.update();
                })
                .onComplete(() => {
                    checkAllComplete();
                })
                .start();
        });
    }
}

/**
 * AYRAÇ: 
 */
export class FikoKonum extends FikoObje3D {
    static SAYAC = 1;
    override type: any = "FikoKamera";
    /** */
    // sahne?: FikoSahne;
    /** */
    // ismi?: string;
    // aciklama?: string;
    // veri?:

    /** */
    sagMenu: any[] = [
        {
            baslik: "Sil",
            simge: "trash",
            tiklandi: () => {
                // Parent'dan (FikoKonumlar) kendini sil
                if (this.parent) {
                    const parent = this.parent as FikoKonumlar;
                    const index = parent.children.indexOf(this);
                    if (index !== -1) {
                        parent.children.splice(index, 1);
                        // Değişikliği bildir
                        this.sahne?.anaGosterim?.FikoYT?.degisti?.emit();
                    }
                }
            }
        }

    ]

    constructor(public override sahne?: FikoSahne, public ismi?: string, public aciklama?: string, public veri?: IKonum) {
        super(sahne);
        if (!ismi || ismi == "") {
            this.ismi = "Fikonum." + FikoKonum.SAYAC;
            this.name = this.ismi;
            FikoKonum.SAYAC += 1;
        } else {
            this.name = this.ismi;
        }

        this.userData.FikoArayuz.agactaGorunur = true;
        this.userData.FikoArayuz.listeGoster = true;
        this.userData.FikoArayuz.simge = "./simgeler/kamera.webp";

    }

    tiklandi() {
        // Eğer veri eksikse eski formatı dönüştür
        if (!this.veri || !this.veri.hedef || !this.veri.position) {
            this.eskiFormatDonustur();
        }
        this.git();
    }

    // Eski matriks tabanlı formatı yeni formata dönüştür
    eskiFormatDonustur() {
        if (!this.veri) return;

        // Eğer veri object içindeyse dışarı çıkar
        if (this.veri.object) {
            const obj = this.veri.object;
            this.veri.position = obj.position || this.veri.position;
            this.veri.quaternion = obj.quaternion || this.veri.quaternion;
            this.veri.scale = obj.scale || this.veri.scale;
            this.veri.ust = obj.up || this.veri.ust;
            this.veri.yakinlik = obj.zoom || this.veri.yakinlik;
            this.veri.matriks = obj.matrix || this.veri.matriks;
        }

        // Eğer eski format (matriks var, position yok)
        if (this.veri.matriks && !this.veri.position) {
            const tempMatrix = new THREE.Matrix4().fromArray(this.veri.matriks);
            const position = new THREE.Vector3();
            const quaternion = new THREE.Quaternion();
            const scale = new THREE.Vector3();
            tempMatrix.decompose(position, quaternion, scale);

            this.veri.position = position.toArray();
            this.veri.quaternion = quaternion.toArray();
            this.veri.scale = scale.toArray();
        }

        // Eğer hedef eksikse varsayılan değer ata
        if (!this.veri.hedef) {
            this.veri.hedef = [0, 0, 0];
        }

        // Eğer ust eksikse varsayılan değer ata
        if (!this.veri.ust) {
            this.veri.ust = [0, 1, 0];
        }

        // Eğer oran eksikse varsayılan değer ata
        if (!this.veri.oran) {
            this.veri.oran = this.sahne?.anaGosterim?.canvas?.nativeElement?.clientWidth / this.sahne?.anaGosterim?.canvas?.nativeElement?.clientHeight || 1;
        }
    }

    async git111(sure = 1000, aktifKamera = this.sahne.anaGosterim.aktifKamera, aktifKontrol = this.sahne.anaGosterim.aktifKontrol) {
        return new Promise((resolve) => {
            // Veri kontrolü - eksik veri varsa işlem yapma
            if (!this.veri || !this.veri.hedef || !this.veri.position || !this.veri.quaternion || !this.veri.ust) {
                resolve(false);
                return;
            }

            // Sürekli çizimi başlat
            this.sahne.anaGosterim.surekliCiz();

            let hedefKontrolPoz = new THREE.Vector3().fromArray(this.veri.hedef);
            let hedefKameraPoz = new THREE.Vector3().fromArray(this.veri.position);
            let hedefKameraQua = new THREE.Quaternion().fromArray(this.veri.quaternion);
            let hedefKameraUst = new THREE.Vector3().fromArray(this.veri.ust);

            let oran = this.sahne.anaGosterim.canvas.nativeElement.clientWidth / this.sahne.anaGosterim.canvas.nativeElement.clientHeight;
            let yeniYakinlik = this.veri.yakinlik && this.veri.oran
                ? (oran * this.veri.yakinlik) / this.veri.oran
                : (this.veri.yakinlik || aktifKamera.zoom);

            let kameraTween = new TWEEN.Tween(aktifKamera.position)
                .to(hedefKameraPoz, sure)
                .easing(TWEEN.Easing.Linear.None);

            let zoomTween = new TWEEN.Tween({ z: aktifKamera.zoom })
                .to({ z: yeniYakinlik }, sure)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate(({ z }) => {
                    aktifKamera.zoom = z;
                    aktifKamera.updateProjectionMatrix();
                });

            let kontrolTween = new TWEEN.Tween(aktifKontrol.target)
                .to(hedefKontrolPoz, sure)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate(() => {
                    aktifKontrol.update?.();
                });

            kameraTween.onStart(() => {
                aktifKamera.quaternion.copy(hedefKameraQua);
                aktifKamera.up.copy(hedefKameraUst);
            });

            zoomTween.onComplete(() => {
                // Animasyon bittiğinde sürekli çizimi durdur
                this.sahne.anaGosterim.surekliCizIptal();
                resolve(true);
            });

            kameraTween.start();
            kontrolTween.start();
            zoomTween.start();
        });
    }


    async git(sure = 750) {
        // Parent'dan gitVeri metodunu kullan (progress-based animation)
        return (this.parent as FikoKonumlar).gitVeri(this.veri, sure);
    }

    git_backup(kamera = this.sahne.anaGosterim.aktifKamera, kontrol = this.sahne.anaGosterim.aktifKontrol) {
        // this.sahne.anaGosterim.surekliCiz();
        kamera.up.fromArray(this.veri.ust);
        // kamera.zoom = this.veri.yakinlik;

        new TWEEN.Tween(kamera)
            .to({ zoom: this.veri.yakinlik }, 1000)
            .onUpdate(() => {
                // kamera.zoom = zoom.zoom;
                // kamera.matrix.decompose(kamera.position, kamera.quaternion, kamera.scale);
                kamera.updateProjectionMatrix()
                this.sahne.anaGosterim.ciz();
                // console.log("guncellendi")
            }).easing(TWEEN.Easing.Quadratic.Out).onComplete(() => {
                // console.log("bitti")
                // this.sahne.anaGosterim.surekliCizIptal();
            })
            .start()

        kamera.matrix.fromArray(this.veri.matriks);
        kamera.matrix.decompose(kamera.position, kamera.quaternion, kamera.scale);

        kontrol.target.fromArray(this.veri.hedef);
        kontrol.update();
        kamera.updateProjectionMatrix()
    }


    kaydet(kamera = this.sahne.anaGosterim.aktifKamera, kontrol = this.sahne.anaGosterim.aktifKontrol) {
        const kameraJSON = kamera.toJSON() as any;
        this.veri = {
            position: kameraJSON.object?.position || kamera.position.toArray(),
            quaternion: kameraJSON.object?.quaternion || kamera.quaternion.toArray(),
            scale: kameraJSON.object?.scale || kamera.scale.toArray(),
            ust: kameraJSON.object?.up || kamera.up.toArray(),
            yakinlik: kameraJSON.object?.zoom || kamera.zoom,
            hedef: kontrol.target.toArray(),
            oran: this.sahne.anaGosterim.canvas.nativeElement.clientWidth / this.sahne.anaGosterim.canvas.nativeElement.clientHeight,
            matriks: kameraJSON.object?.matrix || kamera.matrix.toArray()
        };
    }

    fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        this.name = json.ismi;
        this.ismi = json.ismi;
        this.aciklama = json.aciklama;
        this.veri = json.veri;
    }

    override toJSON() {
        return {
            ismi: this.ismi,
            aciklama: this.aciklama,
            veri: this.veri,
        } as any
    }

}